import React, { useState, useContext, useEffect } from 'react';
import { Accordion, Button, Form } from 'react-bootstrap';
import { loadJson } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import { JSONContext } from '../Store';
import { execSPC, getFilterVariables, getDerivedVariables } from './admin/apiCalls';
import { store, StateProvider } from '../Store';
import { buildQuery } from './queryTemplates';

export default function MigrationModuleForm() {

  const { state, dispatch } = useContext(store);

  const DATABASE_ALIAS = state?.configData && state.configData.dbAlias;
  
  const {
    setResponseJSON,
    setTextSPC,
    setFormTypeQuery,
    formData,
    setFormData,
    setIsLoading,
    setFirstResponseJSON
  } = useContext(JSONContext);
  
  const [filterVariables, setFilterVariables] = useState([]); 
  const [derivedVariables, setDerivedVariables] = useState([]); 
  const [validated, setValidated] = useState(false);
  const [derivedCheckboxes, setDerivedCheckboxes] = useState({});
  const [filterCheckboxes, setFilterCheckboxes] = useState({});

  const navigate = useNavigate();

  // reset form values when page loads
  useEffect(() => {
    setFormData((state?.configData && state?.configData?.enabledDA) ? {'selectedDA': state.configData.enabledDA[0]} : {'selectedDA': 'DAM'});
    // setFormData({'selectedDA': 'DAM'});
    getFilterVariables(setFilterVariables);
    getDerivedVariables(setDerivedVariables);
  }, []);

  const styleTheme = {
    'button': `${state?.configData && state.configData.theme}-button`,
    'title': `${state?.configData && state.configData.theme}-title`,
    'checkButton': `${state?.configData && state.configData.theme}-form-check-input`,
    'formGroup': `${state?.configData && state.configData.theme}-odisea-form-group`,
  }

  const applyFilters = (spcText) => {
    let newSpcText = spcText;
    if (formData?.selectedFilterClasses && formData.selectedFilterClasses.length > 0) {
      let fullNewFilterList = []
      formData.selectedFilterClasses.map((item) => 
        fullNewFilterList.push(`${filterVariables[formData.selectedFilterFeature]['variableName']} = ${item}`)
      );

      newSpcText = spcText.replace(/SELECTION ALL/gi, `filter ${fullNewFilterList.join(' OR ')}`)
    }

    return (newSpcText);
  };

  const submitForm = () => {

    if (
      !formData?.selectedMigration ||
      !formData?.selectedResultType ||
      (formData?.selectedResultType && formData.selectedResultType.length === 0)
    ) {
      alert('Debe completar todos los campos obligatorios del formulario');
      return -1;
    }

    setFormTypeQuery('migration');
    let titleLabel = '';
    let newSpc = 'RUNDEF JOB\nSELECTION ALL\n';
    newSpc = applyFilters(newSpc);

    // iterate for derived tables
    if (formData?.selectedDerivedClasses && formData.selectedDerivedClasses.length > 0) {
      formData.selectedDerivedClasses.map((item, itemIndex) => {
        if (formData.selectedResultType.includes('matrix')) {
          
          // Build the title
          if (formData.selectedMigration === 'rec-pop') {
            titleLabel = `Matriz migración reciente | ${formData.selectedDA}`;
          } else {
            titleLabel = `Matriz migración toda la vida | ${formData.selectedDA}`;
          }
          titleLabel = `${titleLabel} | ${derivedVariables[formData.selectedDerivedFeature]['selectLabel']} = ${derivedVariables[formData.selectedDerivedFeature]['checkItems'].filter(derivedItem => derivedItem.variableValue === item)[0]['label']}`;

          newSpc = newSpc + '\n' + buildQuery(
            'migration', // queryType,
            formData.selectedMigration === 'rec-pop' ? 'matrixRecently' : 'matrixLifetime', //resultType,
            formData.selectedDA, //daType,
            `matrix${itemIndex}`, //tableName
            titleLabel,
            `${itemIndex}`, //indexNumber,
            `${derivedVariables[formData.selectedDerivedFeature]['variableName']} = ${item}`, // filterText,
            `matrix-${itemIndex}` // outputNameJSON
          );
        }
    
        if (formData.selectedResultType.includes('indicators')) {

          // Build the title
          if (formData.selectedMigration === 'rec-pop') {
            titleLabel = `Indicadores migración interna reciente | ${formData.selectedDA}`;
          } else {
            titleLabel = `Indicadores migración interna de toda la vida | ${formData.selectedDA}`;
          }
          titleLabel = `${titleLabel} | ${derivedVariables[formData.selectedDerivedFeature]['selectLabel']} = ${derivedVariables[formData.selectedDerivedFeature]['checkItems'].filter(derivedItem => derivedItem.variableValue === item)[0]['label']}`;

          newSpc = newSpc + '\n' + buildQuery(
            'migration', // queryType,
            formData.selectedMigration === 'rec-pop' ? 'indexRecently' : 'indexLifetime', //resultType,
            formData.selectedDA, //daType,
            `index${itemIndex}`, //tableName
            titleLabel,
            `${itemIndex}`, //indexNumber,
            `${derivedVariables[formData.selectedDerivedFeature]['variableName']} = ${item}`, // filterText,
            `index-${itemIndex}` // outputNameJSON
          );
        }

        return 0;
      });
    } else {
      if (formData.selectedResultType.includes('matrix')) {
        
        // Build the title
        if (formData.selectedMigration === 'rec-pop') {
          titleLabel = `Matriz migración reciente | ${formData.selectedDA}`;
        } else {
          titleLabel = `Matriz migración toda la vida | ${formData.selectedDA}`;
        }

        newSpc = newSpc + '\n' + buildQuery(
          'migration', // queryType,
          formData.selectedMigration === 'rec-pop' ? 'matrixRecently' : 'matrixLifetime', //resultType,
          formData.selectedDA, //daType,
          `matrix0`, //tableName
          titleLabel,
          `0`, //indexNumber,
          '', // filterText,
          `matrix-0` // outputNameJSON
        );
      }
  
      if (formData.selectedResultType.includes('indicators')) {

        // Build the title
        if (formData.selectedMigration === 'rec-pop') {
          titleLabel = `Indicadores migración interna reciente | ${formData.selectedDA}`;
        } else {
          titleLabel = `Indicadores migración interna de toda la vida | ${formData.selectedDA}`;
        }

        newSpc = newSpc + '\n' + buildQuery(
          'migration', // queryType,
          formData.selectedMigration === 'rec-pop' ? 'indexRecently' : 'indexLifetime', //resultType,
          formData.selectedDA, //daType,
          `index0`, //tableName
          titleLabel,
          `0`, //indexNumber,
          '', // filterText,
          `index-0` // outputNameJSON
        );
      }
    }
    
    setTextSPC(newSpc);
    setIsLoading(true);

    execSPC(DATABASE_ALIAS, newSpc, (resp) => {
      //setResponseJSON(resp);
      //console.log(resp);
      let result = {};
      try {
        result = JSON.parse(resp);
      } catch {
        // result = {type: 'Exception', message: 'Error en respuesta desde el servidor'};
        result = {type: 'Exception', message: 'Error en respuesta desde el servidor \n\n' + resp};
      }

      if (result?.type && result.type === 'Exception') {
        result?.message && alert('ERROR EN EL SERVIDOR: ' + result.message);
        navigate(-1);
      }

      setFirstResponseJSON(result); // first response

      // set responses to empty
      setResponseJSON([]);

      // call the API for each result
      const requests = result.outputs.map(async (outputItem) => {
        let responses = {
          path: '',
          data: ''
        }

        await loadJson(result.id, outputItem.file, (jsonResult) => {
          responses.path = `${result.id}/${outputItem.file}`;
          responses.data = jsonResult;
        });
        
        return responses;
      })
      
      // when API finishes loading, set statuses
      Promise.all(requests).then((requests) => {
        setResponseJSON(requests);
        setIsLoading(false);
      });
    });

    navigate('/visualizations');
  }

  let DATypeFormSet = {
    label: 'División Administrativa:',
    controlType: "radio",
    controlClassName: "form-radio",
    name: "damedam",
    items: []
  };
  state?.configData && state?.configData?.enabledDA && state.configData.enabledDA.map((item) => {
    DATypeFormSet.items.push(
      {id: "edit-damedam-" + item, value: item, label: "Distrito - " + item}
    )
  });

  const migrationTypeFormSet = {
    label: 'Tipo de Migración:',
    controlType: "radio",
    controlClassName: "form-radio",
    name: "population",
    items: [
      {id: "edit-population-rec-pop", value: "rec-pop", label: "Fecha fija (Reciente)"},
      {id: "edit-population-nac-pop", value: "nac-pop", label: "Toda la vida"}
    ]
  };

  const resultTypeFormSet = {
    label: 'Tipo de resultado',
    controlType: "checkbox",
    controlClassName: "form-checkbox",
    name: "output[matrix-indicators]",
    items: [
      {id: "edit-output-matrix", value: "matrix", label: "Matriz básica"},
      {id: "edit-output-indicators", value: "indicators", label: "Indicadores"}
    ]
  };

  // validate submit form  
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const submitText = 'Ejecutar';
  const emptySelectText = '- Seleccionar -';

  const DALabels = {
    'DAM': 'Departamento (DAM)',
    'DAMI': 'Provincia (DAMI)',
    'DAME': 'Distrito (DAME)',
  }

  return (
    <>
    {/* JSON.stringify(formData) */}
    <h3> Seleccione Parámetros </h3>
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
    <div className="odisea-parent">
      <div className="odisea-child1">
      <Accordion defaultActiveKey={['0']} alwaysOpen>
        <Accordion.Item className="odisea-form-accordion-item" eventKey="0">
          <Accordion.Header className={ "odisea-form-accordion-header " + styleTheme.title}>Datos obligatorios*</Accordion.Header>
          <Accordion.Body>
          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            <Form.Label className="odisea-form-label" htmlFor="edit-filters">{ DATypeFormSet.label }</Form.Label>
            <Form.Select
              id="edit-alias"
              name="alias"
              onChange={ (e) => {
                  setFormData({
                    ...formData,
                    selectedDA: e.target.value
                  });
              } }
            >
              { DATypeFormSet.items.map((item, itemId) => <option key={ item.id } value={ item.value }>{ DALabels[item.value] }</option>) }
            </Form.Select>
          </Form.Group>
          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            <Form.Label className="odisea-form-label" htmlFor="edit-filters">{ migrationTypeFormSet.label }</Form.Label>
            { migrationTypeFormSet.items.map((item, itemIndex) => 
              <Form.Check
                className={ styleTheme.checkButton } 
                required
                key={ itemIndex }
                type={ migrationTypeFormSet.controlType }
                id={ item.id }
                label={ item.label }
                name={ migrationTypeFormSet.name }
                value={ item.value }
                onChange={ (e) => {
                  if (e.target.checked){
                    setFormData({
                      ...formData,
                      selectedMigration: e.target.value
                    });
                  }
                } }
              />
            )}                   
          </Form.Group>

          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            <Form.Label className="odisea-form-label" htmlFor="edit-filters">{ resultTypeFormSet.label }</Form.Label>
            { resultTypeFormSet.items.map((item, itemIndex) => 
              <Form.Check
                className={ styleTheme.checkButton }
                required
                key = { itemIndex }
                type={ resultTypeFormSet.controlType }
                id={ item.id }
                label={ item.label }
                name={ resultTypeFormSet.name }
                value={ item.value }
                onChange={ (e) => {
                  let selectedResultTypeList = []
                  if (formData.hasOwnProperty('selectedResultType')) {
                    selectedResultTypeList = formData.selectedResultType;
                  }
                  if (e.target.checked){
                    setFormData({
                      ...formData,
                      selectedResultType: [...selectedResultTypeList, e.target.value]
                    });
                  } else {
                    setFormData({
                      ...formData,
                      selectedResultType: selectedResultTypeList.filter(item => item !== e.target.value)
                    });
                  }
                } }
              />
            )}  
          </Form.Group>
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
    </div>
    <div className="odisea-child2">
    <Accordion defaultActiveKey={['0']} alwaysOpen>
    <Accordion.Item className="odisea-form-accordion-item" eventKey="1">
      <Accordion.Header className={ "odisea-form-accordion-header " + styleTheme.title }>Filtros opcionales</Accordion.Header>
      <Accordion.Body>
        <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
          <Form.Label className="odisea-form-label" htmlFor="edit-filters">{ 'Derivada por' }</Form.Label>
          <Form.Select
            id="edit-alias"
            name="alias"
            onChange={ (e) => {
              setFormData({
                ...formData,
                selectedDerivedFeature: e.target.value,
                selectedDerivedClasses: [],
                selectedDerivedClassesLabels: []
              })
              
              setDerivedCheckboxes(derivedVariables[e.target.value]);
            } }
          >
            <option value="" defaultValue="selected">{ emptySelectText }</option>
            { derivedVariables.map((item, itemId) => <option key={ item.id } value={ itemId }>{ item.selectLabel }</option>) }
          </Form.Select>
        </Form.Group>
        <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            { derivedCheckboxes?.checkItems && derivedCheckboxes.checkItems.map((item) => 
              <Form.Check
                className={ styleTheme.checkButton } 
                type={ derivedCheckboxes.controlType }
                key={ item.id }
                label={ item.label }
                name={ derivedCheckboxes.name }
                value={ item.variableValue }
                onChange={ (e) => {
                  let selectedDerivedClasses = [];
                  let selectedDerivedClassesLabels = [];
                  if (formData.hasOwnProperty('selectedDerivedClasses')) {
                    selectedDerivedClasses = formData.selectedDerivedClasses;
                    selectedDerivedClassesLabels = formData.selectedDerivedClassesLabels;
                  }
                  if (e.target.checked){
                    setFormData({
                      ...formData,
                      selectedDerivedClasses: [...selectedDerivedClasses, e.target.value],
                      selectedDerivedClassesLabels: [...selectedDerivedClassesLabels, item.label]
                    });
                  } else {
                    setFormData({
                      ...formData,
                      selectedDerivedClasses: selectedDerivedClasses.filter(item => item !== e.target.value),
                      selectedDerivedClassesLabels: selectedDerivedClassesLabels.filter(i => i !== item.label)
                    });
                  }
                } }
              />
            )}  
        </Form.Group>
        <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
          <Form.Label className="odisea-form-label" htmlFor="edit-filters">Filtrar por: </Form.Label>
          <Form.Select
              id="edit-alias"
              name="alias"
              onChange={ (e) => {
                setFormData({
                  ...formData,
                  selectedFilterFeature: e.target.value,
                  selectedFilterClasses: []
                })
                
                setFilterCheckboxes(filterVariables[e.target.value]);
              } }
            >
              <option value="" defaultValue="selected">{ emptySelectText }</option>
              { filterVariables.map((item, itemId) => <option key={ item.id } value={ itemId }>{ item.selectLabel }</option>) }
          </Form.Select>
        </Form.Group>
        <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            { filterCheckboxes?.checkItems && filterCheckboxes.checkItems.map((item, itemId) => 
              <Form.Check
                className={ styleTheme.checkButton } 
                type={ filterCheckboxes.controlType }
                key={ itemId }
                label={ item.label }
                name={ filterCheckboxes.name }
                value={ item.variableValue }
                onChange={ (e) => {
                  let selectedFilterClasses = []
                  if (formData.hasOwnProperty('selectedFilterClasses')) {
                    selectedFilterClasses = formData.selectedFilterClasses;
                  }
                  if (e.target.checked){
                    setFormData({
                      ...formData,
                      selectedFilterClasses: [...selectedFilterClasses, e.target.value]
                    });
                  } else {
                    setFormData({
                      ...formData,
                      selectedFilterClasses: selectedFilterClasses.filter(item => item !== e.target.value)
                    });
                  }
                } }
              />
            )}  
        </Form.Group>
      </Accordion.Body>
    </Accordion.Item>
  </Accordion>
  <Form.Group className="odisea-form-group odisea-form-group-button">
      <Button type="submit" className={ "odisea-form-button-submit " + styleTheme.button } onClick={() => {submitForm()}}>{submitText}</Button>
  </Form.Group>
  </div>
  </div>
  </Form>
    </>
  )
}
